/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { AbstractControl } from '@angular/forms';
import { ApplicationStateHolder, ControlSchemaType, FormNativeSchema, FormNativeSchemaConfig } from '@gh/common-shared';
import { AbstractBuilderControlSchema } from './abstract-builder-control-schema';

export class BuilderFormNativeSchema extends AbstractBuilderControlSchema implements FormNativeSchema {
  schemaType = ControlSchemaType.Native;

  private control: AbstractControl;

  constructor(stateHolder: ApplicationStateHolder) {
    super(stateHolder);
  }

  update(config: FormNativeSchemaConfig): void {
    super.update(config);

    this.control = config.control;
  }

  build(value?: any): AbstractControl {
    const { control } = this;

    if (!this.isEnabled()) {
      control.disable();
    }

    return control;
  }
}
